<template>
	<div>
		<div class="teacher2 f-cb">
			<div class="teacher2-avatar f-img-box">
				<img :src="userInfo.avatar?userInfo.avatar:teacherAvatar">
			</div>
			<div class="teacher2-content">
				<div class="teacher2-info f-cb">
					<div class="teacher2-name">{{userInfo.nick_name}}</div>
					<div class="teacher2-job">{{userInfo.teacher_title}}</div>
					<div class="teacher2-fans">粉丝 {{userInfo.fans_num}}</div>
				</div>
				<div class="teacher2-place">{{userInfo.department}}</div>
        <div class="teacher2-text" :class="show_all ? '' : 'o3'">{{userInfo.profile}}</div>
        <div style="text-align: center;" @click="show_all = true" v-if="userInfo.profile && !show_all && userInfo.profile.length > 60"><img style="height: .16rem;" src="./more.png"></div>
			</div>
		</div>
		<div class="teacher-tag f-cb">
			<div class="teacher-tag-item" @click="toChild('teacher-lesson')">在线课程（{{lessonNum>=0 ? lessonNum : ""}}）</div>
			<div class="teacher-tag-item teacher-tag-item-active" @click="toChild('teacher-comment')">学生评价</div>
		</div>
		<router-view></router-view>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				userInfo:{},
				lessonNum:-1,
        show_all:false
			}
		},
		created(){
			this.$api.get("",{
				api:"/v1/user/read",
				id:this.$route.params.id,
				user_type:this.tools.getStorage("user_type")
			},(res)=>{
				var data=res.data;
				this.userInfo=data.user_info;
				this.lessonNum=data.classes.length;
			})
		},
		mounted(){
			this.addActive(this.$route.path);
		},
		methods:{
			toChild(name){
				this.$router.replace("/"+name+"/"+this.$route.params.id);
			},
			addActive(path){
				//给导航添加高亮 path：路由路径
				["lesson","comment"].forEach((value,index)=>{
					if(path.indexOf(value)!=-1){
						var doms=document.querySelectorAll(".teacher-tag-item");
						doms.forEach((domValue)=>{
							domValue.className=domValue.className.replace("teacher-tag-item-active","");
						})
						doms[index].className+=" teacher-tag-item-active";
						return;
					}
				})
			}
		},
		beforeRouteUpdate(to,from,next){
			this.addActive(to.path);
			next();
		}
	}
</script>

<style>
	.teacher2{
		padding:0.8rem 0.4rem 0.4rem 0.4rem;
		background: #fff;
	}
	.teacher2-avatar{
		float:left;
		overflow: hidden;
		width:1.44rem;
		height:1.44rem;
		border-radius: 50%;
	}
	.teacher2-content{
		float:right;
		width:7.506rem;
		padding-top:0.226rem;
	}
	.teacher2-info{
		line-height: 0.426rem;
	}
	.teacher2-name{
		float:left;
		font-size: 0.426rem;
		color:#333;
	}
	.teacher2-job{
		float:left;
		margin-left:0.266rem;
		font-size: 0.426rem;
		color:#999;
	}
	.teacher2-fans{
		float:right;
		color:#666;
		font-size: 0.346rem;
	}
	.teacher2-place{
		margin-top:0.266rem;
		font-size: 0.346rem;
		line-height:0.346rem;
		color:#999;
	}
	.teacher2-text{
		margin-top:0.333rem;
		font-size: 0.346rem;
		line-height:0.613rem;
		color:#666;
	}
	.teacher-tag{
		border-top:1px solid #eee;
		border-bottom:1px solid #eee;
	}
	.teacher-tag-item{
		float:left;
		height:1.706rem;
		line-height:1.706rem;
		width:50%;
		background:#fff;
		color:#666;
		text-align: center;
		font-size: 0.426rem;
	}
	.teacher-tag-item-active{
		color:#333;
		background: #f2f2f2;
	}
</style>



// WEBPACK FOOTER //
// src/components/teacher/teacher.vue